import { useSyncExternalStore } from 'react';
import {
  subscribe,
  getSnapshot,
  enableSimulation,
  disableSimulation,
  setIncludeDraftRules,
  setLastResult,
  clearHistory,
  toggleSaveEntry,
} from '@/lib/simulationStore';

/**
 * React hook for simulation mode state.
 * Uses useSyncExternalStore for tear-free reads from the module-level store.
 */
export function useSimulation() {
  const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return {
    /** Whether simulation mode is currently active */
    isActive: state.active,
    /** Whether draft rules are included in simulation */
    includeDrafts: state.includeDrafts,
    /** The last simulation result received from the server */
    lastResult: state.lastResult,
    /** History of simulation results (newest first, max 10) */
    history: state.history,
    /** Enable simulation mode */
    enable: (includeDrafts?: boolean) => enableSimulation(includeDrafts),
    /** Disable simulation mode */
    disable: disableSimulation,
    /** Toggle draft rules inclusion */
    setIncludeDrafts: setIncludeDraftRules,
    /** Clear the last simulation result */
    clearResult: () => setLastResult(null),
    /** Clear all history */
    clearHistory,
    /** Toggle saved/pinned state for a history entry by timestamp */
    toggleSaveEntry,
  };
}
